import { TRUE } from "../grammar/utils/consts";
import { round } from "../utils/Number";

export class EvaluationResult {
    private result: string;

    constructor(result: string) {
        this.result = result;
    }

    asBoolean() {
        if (typeof this.result === "string") {
            if (/^-?[0-9]+(\.[0-9]+)?$/.test(this.result)) return parseFloat(this.result) > 0;
            return this.result === TRUE;
        }
        if (typeof this.result === "number") return this.result > 0;
        if (typeof this.result === "boolean") return this.result;
        return false;
    }

    asNumber() {
        if (typeof this.result === "string" && /^-?[0-9]+(\.[0-9]+)?$/.test(this.result))
            return round(parseFloat(this.result));
        if (typeof this.result === "number" && !isNaN(this.result)) return round(this.result);
        if (typeof this.result === "boolean" && this.result) return 1;
        return 0;
    }

    asString() {
        return String(this.asAny());
    }

    asAny() {
        if (typeof this.result === "number") {
            if (isNaN(this.result)) return 0;
            return round(this.result);
        }
        return this.result;
    }
}
